export {Promotion as Page};

import {Helmet} from "react-helmet-async";
import {useEffect, useState, useContext} from "preact/hooks";
import {AccountSidebar} from "../../../components/AccountSidebar.jsx";
import {ContentLocked} from "../../../components/ContentLocked.jsx";
import messages from "../../../messages/messages.js";
import API_URL from "../../../includes/api.js";
import {NotificationContext} from '../../../components/NotificationContext.jsx';
import {useAuth} from '../../../components/AuthProvider.jsx';
import {CircleSpinner, RingSpinner} from '../../../components/Spinner.jsx';

function Promotion() {

    const {addNotification} = useContext(NotificationContext);
    const {getToken, user, authLoading} = useAuth();

    const [allowed, setAllowed] = useState(false);
    const [loading, setLoading] = useState(false);
    const [pageLoading, setPageLoading] = useState(true);
    const [channel, setChannel] = useState("");
    const [share, setShare] = useState("");
    const [promotionDates, setPromotionDates] = useState([]);

    useEffect(() => {
        if (authLoading) return;

        if (!user) return;

        getToken().then(token => {
            fetch(API_URL + "/promotion/get?firebase_auth_token=" + token)
                .then(response => response.json()).then(data => {
                if (data.code === 200) {
                    setAllowed(true);
                    setChannel(data.data.youtube_channel);
                    setShare(data.data.youtube_share);
                    setPromotionDates(data.data.promotion_calendar)
                } else {
                    setAllowed(false);
                    setChannel("");
                    setShare("");
                    setPromotionDates([]);
                }
            }).finally(() => {
                setPageLoading(false);
            });
        });
    }, [authLoading, user])

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        const token = await getToken();
        const formData = new FormData();
        formData.append("youtube_channel", channel);
        formData.append("youtube_share", share);
        formData.append("firebase_auth_token", token);

        fetch(API_URL + "/promotion/save", {
            method: "POST",
            body: formData
        }).then(response => response.json()).then(data => {
            if (data.code === 200) {
                addNotification('Your channel promotion has been saved!', 'success');
            } else {
                addNotification(data.message, 'error');
            }
        }).catch((error) => {
            addNotification(error.message, 'error');
        }).finally(() => {
            setLoading(false);
        });
    }

    return (
        <section className="text-white">

            <Helmet>
                <title>{messages["SITE.NAME"]} | My channel promotions</title>
                <meta name="description" content="My channel promotions"/>
            </Helmet>

            <div>

                <div className="flex flex-wrap">

                    <AccountSidebar/>

                    {pageLoading ? (
                        <div className="w-full md:w-3/4 px-0 md:px-4">
                            <div className="p-6 text-white rounded-lg bg-zinc-800">
                                <div className="flex items-center">
                                    <CircleSpinner/>
                                    <h3 className="text-lg m-0">Loading...</h3>
                                </div>
                            </div>
                        </div>
                    ) : (
                        !allowed ? (
                            <div className="w-full md:w-3/4 px-0 md:px-4">
                                <ContentLocked/>
                            </div>
                        ) : (
                            <div className="w-full md:w-3/4 px-0 md:px-4">
                                <div className="border border-border/60 bg-zinc-800 rounded-lg p-6 mb-4">
                                    <h3 className="text-xl mt-0 mb-2">My promotion details</h3>
                                    <p className="mb-4 text-sm text-gray-400">Please enter your YouTube channel and a
                                        video to promote below.
                                        We will then promote your video on our website and discord.</p>
                                    <form onSubmit={handleSubmit}>
                                        <div className="flex flex-wrap -mx-3 mb-4">
                                            <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                                                <label htmlFor="youtube_channel"
                                                       className="block mb-2 text-sm font-medium text-white">YouTube
                                                    Channel</label>
                                                <input type="url" name="youtube_channel" id="youtube_channel"
                                                       value={channel}
                                                       onChange={e => setChannel(e.target.value)}
                                                       className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg block w-full p-2.5"
                                                       placeholder="YouTube Channel" required/>
                                            </div>

                                            <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                                                <label htmlFor="youtube_share"
                                                       className="block mb-2 text-sm font-medium text-white">Video to
                                                    promote</label>
                                                <input type="url" name="youtube_share" id="youtube_share"
                                                       value={share}
                                                       onChange={e => setShare(e.target.value)}
                                                       className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg block w-full p-2.5"
                                                       placeholder="Video to promote" required/>
                                            </div>
                                        </div>
                                        <button type="submit"
                                                className="text-white cursor-pointer border border-white hover:bg-white hover:text-black font-medium rounded-lg text-sm px-10 py-2.5 text-center">Save {loading && (
                                            <RingSpinner/>)}
                                        </button>
                                    </form>
                                </div>
                                {channel && share && (
                                    <div className="bg-zinc-800 w-1/2 rounded-lg p-6">
                                        <h3 className="text-xl mt-0 mb-2">My channel promotions</h3>
                                        <p className="mb-4 text-sm text-gray-400">The dates below show when your channel
                                            will be promoted on
                                            our website and discord.</p>

                                        {promotionDates?.length > 0 ? (
                                            <table className="table-auto w-full">
                                                <thead>
                                                <tr>
                                                    <th className="text-left">Date</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {promotionDates.map((date) => (
                                                    <tr>
                                                        <td className="text-left">
                                                            <b className="text-red-400">{date.date.substring(0, 10)}</b>
                                                        </td>
                                                    </tr>
                                                ))}
                                                </tbody>
                                            </table>
                                        ) : (
                                            <p className="mb-4">You have no promotions scheduled (yet).</p>
                                        )}

                                    </div>
                                )}
                            </div>
                        ))}

                </div>

            </div>
        </section>
    );
}
